import { ErrorInfo, ComponentType, PropsWithChildren } from 'react';
import { WithColor } from '@styles/colors';

export interface ErrorBoundaryProps extends PropsWithChildren {
  screenName?: string;
  FallbackComponent?: ComponentType<ErrorFallbackProps>;
  onError?: (error: Error, errorInfo: ErrorInfo) => void;
  resetKey?: string | number;
}

export interface ErrorData {
  error: Error | null;
  errorInfo: ErrorInfo | null;
}

export interface ErrorFallbackProps extends WithColor, ErrorData {
  screenName?: string;
  sessionId?: string;
  onRetry: () => void;
  onGoBack: () => void;
  onReportProblem: () => void;
  onGoHome: () => void;
}

export type RootErrorFallbackProps = ErrorFallbackProps;

export enum InlineErrorFallbackSize {
  Full = 'full',
  Compact = 'compact',
  Micro = 'micro',
}

// compact is a legacy alias for InlineErrorFallbackSize.Compact
export type InlineErrorFallbackProps = ErrorFallbackProps & { compact?: boolean; size?: InlineErrorFallbackSize };

export interface InlineErrorBoundaryProps extends ErrorBoundaryProps {
  compact?: boolean;
  size?: InlineErrorFallbackSize;
}
